import { createI18n } from "vue-i18n";
import en from "../locales/en.json";
import sk from "../locales/sk.json";

const i18n = createI18n({
  legacy: false,
  locale: "sk", // default to Slovak
  fallbackLocale: "en",
  messages: {
    en,
    sk,
  },
});

export default i18n;
